<template>
  <NavBar>
    <div slot="left" @click="showMine">
<!--      <var-icon dot>-->
<!--        <img src="~@/assets/image/icon/notice.png" alt="">-->
<!--      </var-icon>-->
<!--            <van-icon name="friends-o" size="25" />-->
        <van-image class="main-img" style="width: 20px; height: 20px;" :src="require('@/assets/image/icon/icon_top_app@2x.png')"/>
    </div>
    <div slot="title" class="font-title" @click="showHome"><span style="font-size: 16px; font-weight: 900; letter-spacing:1px;">{{commonText.title}}</span></div>
    <div slot="right"  @click="showCart">
<!--      <img src="@/assets/image/icon/search.png" @click.stop="searchShop">-->
<!--        <van-icon name="shopping-cart" @click.stop="showCart" size="30"/>-->
<!--        <van-icon name="shopping-cart-o" style="color: #1b1f23" size="25" @click.stop="showCart" />-->
        <van-image class="main-img" style="width: 24px; height: 24px;" :src="require('@/assets/image/icon/icon_top_gouwuche@2x.png')"/>
<!--      <img src="@/assets/image/icon/shopping_cart.png" @click.stop="showCart">-->
    </div>
  </NavBar>
</template>

<script>
import NavBar from "@/components/common/navbar/NavBar";
import { Icon, Image } from 'vant'

import { langPackage } from "@/config/lang/homeLang";
import { selectLang } from "@/config/setLanguage"

export default {
  name: "NavBarIndexContent",
  components: {
    [Icon.name]: Icon,
    [Image.name]: Image,
    NavBar: NavBar
  },
  data() {
    return {
        commonText:"",
        token:""
    };
  },
  methods: {
        searchShop() {
          this.$router.push({path: '/category'})
        },
        showHome(){
          this.$router.push({path: '/home'})
        },
        showCart() {
          this.$router.push({path: '/order/shoppingCart'})
        },
        showMine(){
            this.$router.push({path: '/mine'})
        }
      },
    created() {
        if (this.$store.getters.token != ""){
            selectLang(langPackage).then(langtxt => {
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            })
        }
    }
}
</script>

<style scoped>
.van-nav-bar {
  /*box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);*/
}
</style>
